document.addEventListener('DOMContentLoaded', function () {
	var headerEl = document.querySelector('.l-header');
	if (!headerEl) return;

	var megaRoot = headerEl.querySelector('.l-header__menu li.mega-menu');
	if (!megaRoot) return;

	var panel = megaRoot.querySelector('.mega-menu__panel');
	if (!panel) return;

	function openMega() {
		megaRoot.classList.add('is-open');
		if (document.body) {
			document.body.classList.add('is-mega-open');
		}
	}

	function closeMega() {
		megaRoot.classList.remove('is-open');
		if (document.body) {
			document.body.classList.remove('is-mega-open');
		}
	}

	var level2Links = panel.querySelectorAll('.mega-menu__link--level2[data-mega-target]');
	var level3Panels = panel.querySelectorAll('.mega-menu__panel-level3[data-mega-panel]');

	function activate(targetId) {
		if (!targetId) return;
		level2Links.forEach(function (a) {
			var isActive = a.getAttribute('data-mega-target') === String(targetId);
			a.classList.toggle('is-active', isActive);
		});
		level3Panels.forEach(function (p) {
			var isMatch = p.getAttribute('data-mega-panel') === String(targetId);
			p.hidden = !isMatch;
		});
	}

	level2Links.forEach(function (a) {
		a.addEventListener('mouseenter', function () {
			openMega();
			activate(a.getAttribute('data-mega-target'));
		});
		a.addEventListener('focus', function () {
			openMega();
			activate(a.getAttribute('data-mega-target'));
		});
	});

	// Utrzymaj otwarte dopóki jesteś w headerze (w tym w dropdownie).
	megaRoot.addEventListener('mouseenter', openMega);
	panel.addEventListener('mouseenter', openMega);
	megaRoot.addEventListener('focusin', openMega);

	headerEl.addEventListener('mouseleave', function (e) {
		var toEl = e.relatedTarget;
		if (toEl && headerEl.contains(toEl)) return;
		closeMega();
	});

	headerEl.addEventListener('focusout', function () {
		setTimeout(function () {
			if (!headerEl.contains(document.activeElement)) {
				closeMega();
			}
		}, 0);
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') closeMega();
	});
});
